import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ReactComponent as DownIcon } from "assets/icons/icon-down-12.svg";
import { ReactComponent as SelectedIcon } from "assets/icons/icon-check-24.svg";
import { ReactComponent as USIcon } from "assets/icons/country/us.svg";
import { ReactComponent as KRIcon } from "assets/icons/country/kr.svg";
import { ReactComponent as VNIcon } from "assets/icons/country/vn.svg";
import { HeaderButtonContainer } from "../Wrapper/headerButton";
import { TextBody2 } from "..";
import { IconWrapper } from "../icon";

const DropdownItem = ({ item, onClick, selected }) => {
  const IconComponent = item.icon;
  return (
    <DropdownItemWrapper onClick={onClick} $selected={selected}>
      <IconWrapper>{IconComponent && <IconComponent />}</IconWrapper>
      <TextBody2 style={{ flexGrow: 1, textAlign: "left" }}>
        {item.text}
      </TextBody2>
      <IconWrapper>{selected && <SelectedIcon />}</IconWrapper>
    </DropdownItemWrapper>
  );
};

export const HeaderLanguageDropdown = ({ showText = false }) => {
  const { i18n } = useTranslation();
  const wrapperRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [currentCode, setLanguageCode] = useState("en");
  const [currentText, setLanguageText] = useState("English");
  const [currentIcon, setLanguageIcon] = useState(USIcon);

  const languages = [
    { value: "en", text: "English", icon: USIcon },
    { value: "ko", text: "한국어", icon: KRIcon },
    // { value: "bs", text: "Bosanski" },
    // { value: "km", text: "ភាសាខ្មែរ" },
    // { value: "zhCN", text: "简体中文" },
    // { value: "zhTW", text: "繁體中文" },
    // { value: "id", text: "Bahasa Indonesia" },
    // { value: "hi", text: "हिंदी" },
    // { value: "ja", text: "日本語" },
    // { value: "lo", text: "ພາສາລາວ" },
    // { value: "my", text: "မြန်မာစာ" },
    // { value: "ms", text: "Bahasa Melayu" },
    // { value: "tl", text: "Tagalog" },
    // { value: "th", text: "ภาษาไทย" },
    { value: "vi", text: "Tiếng Việt", icon: VNIcon },
    // { value: "ta", text: "தமிழ்" },
  ];

  // 외부 클릭 감지
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const lang = languages.find((obj) => obj.value === i18n.language);
    if (lang) {
      setLanguageCode(lang.value);
      setLanguageText(lang.text);
      setLanguageIcon(lang.icon);
    }
  }, [i18n.language]);

  const handleSelect = (option) => {
    i18n.changeLanguage(option.value);
    setLanguageCode(option.value);
    setLanguageText(option.text);
    setLanguageIcon(option.icon);
    setOpen(false);
  };

  return (
    <DropdownWrapper ref={wrapperRef}>
      <DropdownButton
        text={showText && currentText}
        icon={currentIcon}
        onClick={() => setOpen((prev) => !prev)}
        isListOpen={open}
        hideArrow={!showText}
      />
      {open && (
        <DropdownList>
          {languages.map((option) => (
            <DropdownItem
              key={option.value}
              item={option}
              onClick={() => handleSelect(option)}
              selected={currentCode === option.value}
            />
          ))}
        </DropdownList>
      )}
    </DropdownWrapper>
  );
};

///////////////////////////////////////////////////////////////////
const DropdownWrapper = styled.div`
  display: inline-block;
  position: relative;
  height: 100%;
  align-content: center;
`;
const DropdownButton = ({
  text,
  icon: IconComponent,
  onClick,
  hideArrow = false,
  isListOpen,
}) => {
  return (
    <HeaderButtonContainer onClick={onClick}>
      <IconWrapper style={{ cursor: "pointer" }}>
        {IconComponent && <IconComponent />}
      </IconWrapper>
      {text && <TextBody2>{text}</TextBody2>}
      {!hideArrow && (
        <DownIcon
          style={{
            transform: isListOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        />
      )}
    </HeaderButtonContainer>
  );
};

const DropdownList = styled.ul`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  margin-top: 1.5rem;
  padding: 0;

  width: max-content;
  min-width: 100%;
  overflow: auto;

  background-color: var(--White);
  border: 1px solid var(--Gray);
  border-radius: 0.5rem;
  list-style: none;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
  z-index: 10;
`;

const DropdownItemWrapper = styled.li`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  justify-content: start;
  align-items: center;
  cursor: pointer;

  background-color: ${({ $selected }) => ($selected ? "#E9F0F8" : "")};

  &:hover {
    background-color: var(--LightGray);
  }

  & + & {
    border-top: 1px solid var(--Gray);
  }
`;
